export default function getScrollbarWidth() {
  const div = document.createElement("div");
  const styles = {
    width: "100px",
    height: "100px",
    overflowY: "scroll",
    visibility: "hidden",
    position: "fixed",
    top: "-100000px",
    left: "-100000px",
  };
  for (let i in styles) div.style[i] = styles[i];
  document.body.appendChild(div);
  const scrollbarWidth = div.offsetWidth - div.clientWidth;
  div.remove();
  return scrollbarWidth;
}
